
    import '/home/runner/work/GPT-Vis/GPT-Vis/docs/guide/custom-ui.en.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-guide-custom-ui-demo-custom-ui"],
  getter: () => import(/* webpackChunkName: "meta__docs__en" */'/home/runner/work/GPT-Vis/GPT-Vis/docs/guide/custom-ui.en.md?type=demo')
};